/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1AccesscontrolPermissionsSummaryQueryResponse,
  GetApiV1AccesscontrolPermissionsSummaryQueryParams,
  GetApiV1AccesscontrolPermissionsSummary401,
  GetApiV1AccesscontrolPermissionsSummary500,
} from "../../types/accessControlPermissionsController/GetApiV1AccesscontrolPermissionsSummary.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1AccesscontrolPermissionsSummary } from "../../clients/accessControlPermissionsController/getApiV1AccesscontrolPermissionsSummary.ts";

export const getApiV1AccesscontrolPermissionsSummaryQueryKey = (
  params?: GetApiV1AccesscontrolPermissionsSummaryQueryParams,
) =>
  [
    { url: "/api/v1/accesscontrol/permissions/summary" },
    ...(params ? [params] : []),
  ] as const;

export type GetApiV1AccesscontrolPermissionsSummaryQueryKey = ReturnType<
  typeof getApiV1AccesscontrolPermissionsSummaryQueryKey
>;

export function getApiV1AccesscontrolPermissionsSummaryQueryOptions(
  params?: GetApiV1AccesscontrolPermissionsSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1AccesscontrolPermissionsSummaryQueryKey(params);
  return queryOptions<
    GetApiV1AccesscontrolPermissionsSummaryQueryResponse,
    ResponseErrorConfig<
      | GetApiV1AccesscontrolPermissionsSummary401
      | GetApiV1AccesscontrolPermissionsSummary500
    >,
    GetApiV1AccesscontrolPermissionsSummaryQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1AccesscontrolPermissionsSummary(params, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os controllers com os flags de permissão agregados para um role. Um flag é true se ao menos um usuário do role possuir aquela permissão no controller. **(Requer Authorization para autenticação)**
 * @summary Resumo de permissões por role (Requer Authorization para autenticação)
 * {@link /api/v1/accesscontrol/permissions/summary}
 */
export function useGetApiV1AccesscontrolPermissionsSummary<
  TData = GetApiV1AccesscontrolPermissionsSummaryQueryResponse,
  TQueryData = GetApiV1AccesscontrolPermissionsSummaryQueryResponse,
  TQueryKey extends QueryKey = GetApiV1AccesscontrolPermissionsSummaryQueryKey,
>(
  params?: GetApiV1AccesscontrolPermissionsSummaryQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1AccesscontrolPermissionsSummaryQueryResponse,
        ResponseErrorConfig<
          | GetApiV1AccesscontrolPermissionsSummary401
          | GetApiV1AccesscontrolPermissionsSummary500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1AccesscontrolPermissionsSummaryQueryKey(params);

  const query = useQuery(
    {
      ...getApiV1AccesscontrolPermissionsSummaryQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1AccesscontrolPermissionsSummary401
      | GetApiV1AccesscontrolPermissionsSummary500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
